import { StringParam } from 'use-query-params'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { TemplatesListDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'

export const tableSearchQuerySchema: TableSearchQuerySchema<TemplatesListDataSource> = {
  'table-message': StringParam
} as const

export const columnsSearchSchema: ColumnTableSearchSchema<TemplatesListDataSource> = {
  message: { type: columnSearchSchemaOptionType.INPUT }
}
